/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Choose_Settings_FileInputs */

const en_choose_settings_file = /** @type {(inputs: Choose_Settings_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose Settings File`)
};

const fr_choose_settings_file = /** @type {(inputs: Choose_Settings_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisir le fichier de paramètres`)
};

const de_choose_settings_file = /** @type {(inputs: Choose_Settings_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungsdatei auswählen`)
};

const it_choose_settings_file = /** @type {(inputs: Choose_Settings_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli il file delle impostazioni`)
};

const ru_choose_settings_file = /** @type {(inputs: Choose_Settings_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите файл настроек`)
};

const es_choose_settings_file = /** @type {(inputs: Choose_Settings_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar archivo de configuración`)
};

const zh_cn2_choose_settings_file = /** @type {(inputs: Choose_Settings_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择设置文件`)
};

const ja_choose_settings_file = /** @type {(inputs: Choose_Settings_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定ファイルを選択`)
};

const hi_choose_settings_file = /** @type {(inputs: Choose_Settings_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेटिंग्स फ़ाइल चुनें`)
};

const pt_pt2_choose_settings_file = /** @type {(inputs: Choose_Settings_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o arquivo de configurações.`)
};

/**
* | output |
* | --- |
* | "Choose Settings File" |
*
* @param {Choose_Settings_FileInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const choose_settings_file = /** @type {((inputs?: Choose_Settings_FileInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Choose_Settings_FileInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_choose_settings_file(inputs)
	if (locale === "de") return de_choose_settings_file(inputs)
	if (locale === "it") return it_choose_settings_file(inputs)
	if (locale === "ru") return ru_choose_settings_file(inputs)
	if (locale === "es") return es_choose_settings_file(inputs)
	if (locale === "zh-CN") return zh_cn2_choose_settings_file(inputs)
	if (locale === "ja") return ja_choose_settings_file(inputs)
	if (locale === "hi") return hi_choose_settings_file(inputs)
	if (locale === "pt-PT") return pt_pt2_choose_settings_file(inputs)
	return en_choose_settings_file(inputs)
});